<template>
    <div>
        <div>
            <Billingcomponent
                :outerVisible="outerVisible"
                @closeouterVisible="closeouterVisible"
                @InvoiceBackInformation="InvoiceBackInformation"
                :title="title"
                :ruleFormb="allitem.ruleFormb"
                :iszhengshu="false"
                :priceall="allitem.priceall"
                :totalall="allitem.totalall"
                :ruleFormbxiao="allitem.ruleFormbxiao"
                :form_chae="allitem.form_chae"
                :bztext="allitem.bztext"
                :stateall="allitem.stateall"
                :listoflists="allitem.listoflists"
                :invoiceNo="allitem.invoiceNo"
                :invoiceCode="allitem.invoiceCode"
                :billingDate="allitem.billingDate"
                :checkCode="allitem.checkCode"
                :HongChongtype="HongChongtype"
            ></Billingcomponent>
            <kgdiag
                @closekgdialog="closekgdialog"
                :headtitle="kgtitle"
                :kgdialog="kgdialog"
                :tableDatans="tableDatans"
                :tableDatakp="tableDatakp"
                @openInvoice="getCurrntDocInfo"
                @radiochange="radiochange"
            ></kgdiag>


            <DetailsImport :title="title" :kaipr="kaipr" :totalall="totalall" :danjh="danjh" :id="id"
                           :ruleFormbxiao="ruleFormbxiao" :stateall="stateall" :tedxx="tedxx" :bztext="bztext" :jbrdata="jbrdata"
                           :srk="srk" :ruleFormb="ruleFormb" :priceall="priceall" :Preview="Preview" @closediagew="closediagew"
                           :tdywxz="tdywxz"></DetailsImport>

            <InvoiceToSee :hongc='true' :disable='true' :kaipr="kaipr" :bztext="bztext" :fuhr="fuhr" :shoukr="shoukr" :totalall="totalall" :danjh="danjh" :title="title" :id="id"
                          :tedxx="tedxx" :jazsxz="jazsxz" :cezsxz="cezsxz" :tdywxz="tdywxz" :jbrdata="jbrdata" :srk="srk"
                          :ruleFormb="ruleFormb" :priceall="priceall" :entering="entering" @closediaglr="closediaglr"
                          :ruleFormbxiao="ruleFormbxiao" :stateall="stateall" :itemVlue="itemVlue" @InvoiceBackInformation="InvoiceBackInformation">
            </InvoiceToSee>

            <!--  身份验证  -->
            <Authentication :authenticationDialogShowFlag='authenticationDialogShowFlag' :smsOrQrCode='smsOrQrCode' :qrCode='qrCode' @closeAuthenticationDialog='closeAuthenticationDialog'></Authentication>

            <!-- 修改自定义说明二修改 -->
            <el-dialog title="修改自定义说明二" :visible.sync="dialogApproval" width="100px;" v-dialogDrag>
                <taxform :Formlist="formlist" ref="taxForm" :formdata="formdata"></taxform>
                <div style="justify-content: center;margin-top: 40px; display: flex;">
                    <div class="backstyle" style="margin-right: 30px;margin-left: 30px; margin-bottom: 20px;" @click="dialogApproval = false">返回</div>
                    <div class="addstyle" style="margin-bottom: 20px;" @click="submitFrom">提交</div>
                </div>
            </el-dialog>
            <taxSearch :searchdata="searchalllist" :searchlist="searchlist" labelwidth="150px" labelPosition="left" @submitSearch="forshuai"></taxSearch>
            <div class="headline"></div>
            <div class="areacontent" >
                <div class="">
                    <div class="Centerupdown">
                        <div class="between-line">
                            <el-dropdown style="width: 100px;margin-right: 10px;" v-permission="fpfstk_fspptk_hc">
                                <div class="addstyle" style="width: 100px;margin-right: 10px;">
                                    <samp>
                                        红冲
                                        <i class="el-icon-caret-bottom el-icon--right" style="padding-left:8px;"></i>
                                    </samp>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item @click.native="batchRedPunch">红冲</el-dropdown-item>
                                    <!--                                    <el-dropdown-item @click.native="plhc(2)">红冲重开</el-dropdown-item>-->
                                </el-dropdown-menu>
                            </el-dropdown>
                            <!-- <el-button type="primary" plain style="width: 100px;margin-right: 10px;" @click="excelExport" v-permission='fpfstk_fspptk_dclb'>
                导出列表
                <i class="el-icon-thumb el-icon--right"></i>
              </el-button> -->
                            <div class="addstyle" @click="excelExport" style="width: 100px;margin-right: 10px;" v-permission="fpfstk_fspptk_dclb">
                                <samp>
                                    导出列表
                                    <i class="el-icon-thumb el-icon--right"></i>
                                </samp>
                            </div>
                            <!--  <el-button style="margin-left: 5px;" type="primary" plain @click="openUpdateZidysm2()">
                修改自定义说明二
              </el-button> -->
                            <div class="addstyle" @click="openUpdateZidysm2()" style="width: 130px;margin-right: 10px;"><samp>修改自定义说明二</samp></div>
                        </div>
                    </div>
                </div>
                <!--   <div class="end-flex" style="margin-top: 20px">
          <div class="Centerupdown">
            <div class="between-line">
              <el-dropdown style="width: 120px;margin-right: 10px;" v-permission='fpfstk_fspptk_qzhckz'>
                <el-button type="primary"  plain  style="width: 120px; "> 强制红冲控制
                  <i class="el-icon-caret-bottom el-icon--right" ></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="updateRedBluntSign(1)">置为强制红冲</el-dropdown-item>
                  <el-dropdown-item @click.native="updateRedBluntSign(0)">取消强制红冲</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-dropdown style="width: 100px;margin-right: 10px;" v-permission='fpfstk_fspptk_hc'>
                <el-button type="primary"  plain  style="width: 100px; padding-left:30px;"> 红冲
                  <i class="el-icon-caret-bottom el-icon--right" style="padding-left:8px;"></i></el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="plhc(1)">红冲</el-dropdown-item>
                  <el-dropdown-item @click.native="plhc(2)">红冲重开</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button type="primary" plain style="width: 100px;margin-right: 10px;" @click="excelExport" v-permission='fpfstk_fspptk_dclb'>
                导出列表
                <i class="el-icon-thumb el-icon--right"></i>
              </el-button>
            </div>
          </div>
          <div class="Centerupdown">
            <el-button style="margin-left: 5px;" type="primary" plain @click="openUpdateZidysm2()">
              修改自定义说明二
            </el-button>
          </div>
        </div> -->
                <div class="areatable">
                    <div class="tableh">
                        <template>
                            <el-table
                                :data="tableData"
                                border
                                style="width: 100%"
                                ref="multipleTable"
                                height="calc(100vh - 437px )"
                                @selection-change="handleSelectionChange"
                                @row-click="selectClick"
                                @sort-change="tableSortChange"
                            >
                                <el-table-column type="selection" width="55" fixed="left"></el-table-column>
                                <el-table-column prop="stateall.docNo" align="left" min-width="160px" show-overflow-tooltip label="单据号"></el-table-column>
                                <el-table-column label="发票类型" prop="stateall.choosetitleindex" sortable="custom" min-width="100" align="center">
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.stateall.choosetitleindex == '026'">电子普票</p>
                                        <p v-if="scope.row.stateall.choosetitleindex == '028'">电子专票</p>
                                        <p v-if="scope.row.stateall.choosetitleindex == '007'">纸质普票</p>
                                        <p v-if="scope.row.stateall.choosetitleindex == '004'">纸质专票</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="documentStatus" label="发票状态" min-width="100" align="center" key="3">
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.documentStatus == '4'" style="color:#FF8000">已开票</p>
                                        <p v-if="scope.row.documentStatus == '6'" style="color:#FF8000">已红冲</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="forceRedFlushStatus" label="强制红冲状态" min-width="100" align="center" key="3">
                                    <template slot-scope="scope">
                                        <p v-if="scope.row.forceRedFlushStatus != '1'">否</p>
                                        <p v-if="scope.row.forceRedFlushStatus == '1'">是</p>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="invoiceCode" sortable="custom" label="发票代码" min-width="100" align="center"></el-table-column>
                                <el-table-column prop="invoiceNo" sortable="custom" label="发票号码" min-width="100" align="center"></el-table-column>

                                <el-table-column prop="ruleFormb.customerName" label="购方名称" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="ruleFormb.taxIdentificationNumber" label="购方税号" align="left" min-width="160px" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <div>{{ scope.row.ruleFormb.taxIdentificationNumber }}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="totalall.pricetotal" label="原金额" align="right" min-width="100">
                                    <template slot-scope="scope">
                                        <span>{{ toThousands(Amountformat(scope.row.totalall.pricetotal)) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="totalall.taxtotal" label="原税额" align="right" min-width="100">
                                    <template slot-scope="scope">
                                        <span>{{ toThousands(Amountformat(scope.row.totalall.taxtotal)) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="totalall.jiastotal " label="原价税合计" align="right" min-width="100">
                                    <template slot-scope="scope">
                                        <span>{{ toThousands(Amountformat(scope.row.totalall.jiastotal)) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="开票日期" align="left" min-width="160px" show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span>{{ yyyyMMdd(scope.row.billingDate) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="totalall.pricetotal" label="实开金额" align="right" min-width="100">
                                    <template slot-scope="scope">
                                        <span>{{ toThousands(Amountformat(scope.row.totalall.yihcje)) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="totalall.taxtotal" label="实开税额" align="right" min-width="100">
                                    <template slot-scope="scope">
                                        <span>{{ toThousands(Amountformat(scope.row.totalall.yihcse)) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="totalall.jiastotal " label="实开价税合计" align="right" min-width="100">
                                    <template slot-scope="scope">
                                        <span>{{ toThousands(Amountformat(scope.row.totalall.yihcjshj)) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="stateall.zhidr" label="制单人" min-width="100" align="center"></el-table-column>
                                <el-table-column prop="zidysm" label="自定义说明" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="zidysm2" label="自定义说明二" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
                                <el-table-column prop="stateall.kaipzddm" label="税盘编号" align="left" min-width="160px" show-overflow-tooltip></el-table-column>
                                <el-table-column fixed="right" label="操作" min-width="160" align="center">
                                    <template slot-scope="scope">
                                        <el-button @click="handleClick(scope.row, '预览原发票')" type="text" size="small" v-permission="fpfstk_fspptk_ckyp">查看原票</el-button>
                                        <el-button @click.stop="forhongchong(scope.row)" type="text" size="small" style="color: red;" v-permission="fpfstk_fspptk_lbhc">
                                            红冲
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </template>
                    </div>
                    <div class="lastend">
                        <div>
                            当前已勾选
                            <span>{{ selectCount }}</span>
                            条
                        </div>
                        <div>
                            合计金额
                            <span>{{ toThousands(Amountformat(selectJine)) }}</span>
                        </div>
                        <div>
                            合计税额
                            <span>{{ toThousands(Amountformat(selectShuie)) }}</span>
                        </div>
                    </div>
                    <div class="buttompage">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :page-sizes="[10, 20, 100, 500]"
                            :key="elementui_page_component_key"
                            :current-page="currentpage"
                            :page-size="pagenum"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalcount"
                        ></el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import zhuanpiao from './FilloutZhuannegativeinvoice.vue';
import configHttp from '../../../../../configHttp';
import DetailsImport from '../FillingPositiveInvoice/DetailsImport/index.vue';
import InvoiceToSee from '../FillingPositiveInvoice/InvoiceToSee/index.vue';
import Authentication from '@/components/page/FullyElectronicInvoices/FillingPositiveInvoice/Authentication';
export default {
    components: {
        zhuanpiao,DetailsImport,InvoiceToSee,Authentication
    },
    data() {
        return {
            searchlist: [
                {
                    prop: 'faplxdm',
                    label: '发票类型',
                    type: 'select',
                    selectval: [
                        {
                            label: '电子普票',
                            value: '026'
                        },
                        {
                            label: '纸质普票',
                            value: '007'
                        },
                        {
                            label: '全部',
                            value: ''
                        }
                    ]
                },	{
                    prop: 'faphm',
                    label: '发票号码',
                    type: 'input'
                },
                {
                    prop: 'fapdm',
                    label: '发票代码',
                    type: 'input'
                },

                {
                    prop: 'fpalldate',
                    label: '开票日期',
                    type: 'date',
                    valueformat: 'yyyy-MM-dd'
                },
                {
                    prop: 'docNo',
                    label: '单 据 号',
                    type: 'input'
                },
                {
                    prop: 'purchaserName',
                    label: '购方名称',
                    type: 'input'
                },
                {
                    prop: 'purchaserTaxNumber',
                    label: '购方税号',
                    type: 'input'
                },
                {
                    prop: 'kaipzddm',
                    label: '税盘编号',
                    type: 'input'
                },
                {
                    prop: 'yuanHejje',
                    label: '原金额',
                    type: 'input'
                },
                {
                    prop: 'yuanHejse',
                    label: '原税额',
                    type: 'input'
                },
                {
                    prop: 'fapzt',
                    label: '单据状态',
                    type: 'select',
                    selectval: [
                        {
                            label: '全部',
                            value: ''
                        },
                        {
                            label: '已开票',
                            value: '4'
                        },
                        {
                            label: '已红冲',
                            value: '6'
                        }
                    ]
                },
                {
                    prop: 'zidysm',
                    label: '自定义说明',
                    type: 'input'
                },
                {
                    prop: 'forceRedFlushStatus',
                    label: '强制红冲状态',
                    type: 'select',
                    selectval: [
                        {
                            label: '全部',
                            value: ''
                        },
                        {
                            label: '是',
                            value: '1'
                        },
                        {
                            label: '否',
                            value: '0'
                        }
                    ]
                }
            ],
            checkmeauList: [
                '单据号',
                '发票类型',
                '发票代码',
                '发票号码',
                '购方名称',
                '购方税号',
                '原金额',
                '原税额',
                '原价税合计',
                '开票日期',
                '实开金额',
                '实开税额',
                '实开价税合计',
                '制单人'
            ],
            checkHeadFiled: ['danjh', 'faplxdm', 'fapdm', 'faphm', 'goufmc', 'goufsbh', 'hejje', 'hejse', 'jiashj', 'kaiprq', 'yihcje', 'yihcse', 'yihcjshj', 'zhidr'],
            formLabelWidth: '150px',
            cxdialog: false,
            kgdialog: false,
            kgtitle: ['红冲'],
            tableDatans: [{}],
            tableDatakp: [{}],
            isshou: true,
            page: 1,
            kaijuType: '',
            pagenum: 10,
            totalcount: 0,
            serchform: {},
            tableData: [],
            headtitle: ['发票管理', '负数普票填开'],
            cxtitle: ['高级查询'],
            serchval: '',
            title: '',
            allitem: {},
            outerVisible: false,
            chooseitem: {},
            deletecommids: '',
            /* 高级查询搜索条件 */
            searchalllist: {
                docNo: '',
                docStartDate: '',
                docEndDate: '',
                excludeTaxAmount: '',
                includeTaxAmount: '',
                type: '1',
                purchaserName: '',
                purchaserTaxNumber: '',
                reviewer: '',
                issuer: '',
                faplxdm: '',
                payee: '',
                billingStartdate: '',
                billingEnddate: '',
                fpalldate: '',
                Documentstatus_g: '',
                //搜索
                listlikeSearch: '',
                kaipzddm: '',
                forceRedFlushStatus: ''
            },
            serchFormRules: {
                excludeTaxAmount: [{ validator: this.validateHejjeAndHejse, trigger: 'blur' }],
                includeTaxAmount: [{ validator: this.validateHejjeAndHejse, trigger: 'blur' }],
                purchaserTaxNumber: [{ validator: this.validateCustomersbh, trigger: 'blur' }]
            },
            selectCount: '0',
            selectJine: '0.00',
            selectShuie: '0.00',
            selectRow: {},
            selectRows: [],
            HongChongtype: 'pu',
            kaipzddm: '',
            tableHeight: '',
            currentpage: 1,
            elementui_page_component_key: '',
            fpxlxoptions: [
                {
                    label: '电子普票',
                    value: '026'
                },
                {
                    label: '纸质普票',
                    value: '007'
                },
                {
                    label: '全部',
                    value: ''
                }
            ],
            choosetitleindex: '0',
            isQuery: false,
            // 红冲类型 ：1、红冲 2、红冲重开
            type: '',
            formlist: [
                {
                    prop: 'text',
                    label: '修改自定义说明二',
                    type: 'textarea',
                    isnotnull: true
                }
            ],
            formdata: {
                text: ''
            },
            dialogApproval: false,
            sort: '',
            order: '',

            //开票人
            kaipr: '',
            //合计
            totalall: {},
            //单据号
            danjh: '',
            id: '',
            //销方信息
            ruleFormbxiao: {
                name: '', //销售方名称
                taxNumber: '', //销售方名称纳税人识别号
                addressPhone: '', //销售方名称地 址、电 话
                bankAccount: '', //销售方名称开户行及账号
                bpayee: '', //收款人
                breview: '', //复 核
                bdrawer: '' //开票人
            },
            //状态
            stateall: {
                istaxincluded: false, //是否含税
                choosetitleindex: '' //发票类型 新增也要传
            },
            //特定业务类型
            tedxx: {
                qiybh: '',
                jianzfwfsd: '',
                fasdxxdz: '',
                jianzxmmc: '',
                tudzzsxmbh: '',
                budcdz: '',
                budcxxdz: '',
                zulqqzulqz: ['', ''],
                kuadsbz: '',
                budcqzhm: '',
                mianjdw: ''
            },
            //备注
            bztext: '',
            //经办人信息
            jbrdata: {
                xingm: '',
                guoj: '',
                zhengjlx: '',
                bank: '',
                qiybh: ''
            },
            //附加信息
            srk: [],
            //购方信息
            ruleFormb: {
                customerNumber: '', //客户编号
                customerName: '', //购买方名称
                taxIdentificationNumber: '', //购买方纳税人识别号
                address: '', //购买方地 址、电 话
                bank: '' //购买方开户行及账号
            },
            //票据明细
            priceall: [{}, {}, {}, {}, {}, {}, {}, {}],
            Preview: false,
            //特定业务
            tdywxz: '',


            entering:false,
            //特定业务
            //差额征税 减按征税
            cezsxz: '',
            jazsxz: '',
            itemVlue:'',



            authenticationDialogShowFlag:false,
            smsOrQrCode:"sms",
            qrCode:"",
        };
    },
    created() {
        // this.getDocList()
    },
    mounted() {
        this.repairtable();
    },
    methods: {
        closeAuthenticationDialog(){
            this.authenticationDialogShowFlag = false;
        },
        closediaglr() {
            this.entering = false;
            this.authenticationDialogShowFlag = false;
        },
        //
        InvoiceBackInformation(v) {
            this.$confirm('此操作将进行红冲, 是否继续?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let user = localStorage.getItem("useropj");
                let userInfo = JSON.parse(user);
                let qiybhCode = userInfo.currCompany.code;
                this.$https.fetchGet('rpa/fastRedPunch', {qiybh:qiybhCode,ids:v}).then(res => {
                    this.entering = false;
                    if (res.data.code == '200') {
                        if(res.data.data != null && res.data.data.returncode == '2001') {
                            if (res.data.data.returndata.hasOwnProperty("type")) {
                                this.$message.error(res.data.data.returnmsg);
                                if (res.data.data.returndata.type == '1') {
                                    this.smsOrQrCode = "sms"
                                    this.qrCode = "";
                                    this.authenticationDialogShowFlag = true;
                                } else if (res.data.data.returndata.type == '2') {
                                    this.smsOrQrCode = "qr"
                                    this.qrCode = res.data.data.returndata.qrCode;
                                    this.authenticationDialogShowFlag = true;
                                }
                                return;
                            } else {
                                this.$message.error(res.data.data.returnmsg);
                                return;
                            }
                        }
                        this.$message.success("红冲成功");
                    } else {
                        this.$message.error(res.data.message);
                    }
                    this.getDocList();
                })
            });
        },
        repairtable() {
            this.$nextTick(() => {
                this.tableHeight = this.diagheightzhengshutiankai();
                setTimeout(() => {
                    this.$refs.multipleTable.doLayout();
                }, 300);
                window.onresize = () => {
                    this.tableHeight = this.diagheightzhengshutiankai();
                    setTimeout(() => {
                        this.$refs.multipleTable.doLayout();
                    }, 300);
                };
            });
        },

        //批量红冲
        batchRedPunch(){
            if (this.emptyandnull(this.selectRows)) {
                this.$message.error('请选择批量红冲数据');
                return false;
            }
            for (let i = 0; i < this.selectRows.length; i++) {
                if (this.selectRows[i].documentStatus != '4') {
                    this.$message.error('只能选择已开票的数据！');
                }
            }
            this.$confirm('此操作将进行批量红冲, 是否继续?', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {


                let user = localStorage.getItem("useropj");
                let userInfo = JSON.parse(user);
                let qiybhCode = userInfo.currCompany.code;

                let ids = this.selectRows.map(item=> item.id);
                this.$https.fetchGet('rpa/fastRedPunch', {qiybh:qiybhCode,ids:ids.join(",")}).then(res => {
                    console.log(res);
                    if (res.data.code == '200') {
                        if(res.data.data != null && res.data.data.returncode == '2001') {
                            if (res.data.data.returndata.hasOwnProperty("type")) {
                                this.$message.error(res.data.data.returnmsg);
                                if (res.data.data.returndata.type == '1') {
                                    this.authenticationDialogShowFlag = true;
                                    this.smsOrQrCode = "sms"
                                    this.qrCode = "";
                                } else if (res.data.data.returndata.type == '2') {
                                    this.authenticationDialogShowFlag = true;
                                    this.smsOrQrCode = "qr"
                                    this.qrCode = res.data.data.returndata.qrCode;
                                }
                                return;
                            } else {
                                this.$message.error(res.data.data.returnmsg);
                                return;
                            }

                        }
                        this.$message.success("红冲成功");

                    } else {
                        this.$message.error(res.data.message);
                    }

                    this.getDocList();
                })
            });
        },

        handleSelectionChange(e) {
            this.selectCount = 0;
            this.selectJine = 0;
            this.selectShuie = 0;
            let hejje = 0;
            let hejse = 0;
            let count = 0;
            this.selectRows = [];
            e.forEach((item, index) => {
                count++;
                hejje = this.printFn(parseFloat(hejje) + parseFloat(item.totalall.pricetotal));
                hejse = this.printFn(parseFloat(hejse) + parseFloat(item.totalall.taxtotal));
                this.selectRows.push(item);
            });
            this.selectCount = count;
            this.selectJine = hejje;
            this.selectShuie = hejse;
        },
        selectClick(row, column, event) {
            this.$refs.multipleTable.toggleRowSelection(row);
        },
        tableSortChange(column, prop, order) {
            this.order = column.prop;
            if (column.order) {
                this.sort = column.order.replace('ending', '');
            } else {
                this.sort = '';
                this.order = '';
            }
            this.forshuai();
        },
        changeshou() {
            this.isshou = !this.isshou;
        },
        clickchoosetap() {},
        resetForm(formName) {
            Object.keys(this.searchalllist).map(key => (this.searchalllist[key] = ''));
            this.searchalllist.type = '1';
        },
        forshuai() {
            this.isQuery = true;
            this.elementui_page_component_key++;
            this.currentpage = 1;
            if (this.searchalllist.fpalldate) {
                this.searchalllist.billingStartdate = this.searchalllist.fpalldate[0];
                this.searchalllist.billingEnddate = this.searchalllist.fpalldate[1];
            }
            this.searchalllist.listlikeSearch = '';
            this.getDocList();
        },
        /* 接口数据 */
        /* 获取开票管理表格区列表数据 */
        getDocList() {
            var newform = JSON.parse(JSON.stringify(this.searchalllist));
            delete newform['fpalldate'];
            newform.type = '2';
            newform.fapzl = "2";



            let params = {
                likeSearch: this.searchalllist.listlikeSearch,
                page: this.page,
                limit: this.pagenum,
                sort: this.sort,
                order: this.order,
                search: newform
            };

            //todo 需要加双日判断
            if (configHttp.shuangRiTaxNumber) {
                let shuangRiTaxNumber = configHttp.shuangRiTaxNumber;
                let userobj = JSON.parse(localStorage.getItem('useropj'));
                let qiybh = userobj.currCompany.code;
                if (shuangRiTaxNumber.includes(qiybh)) {
                    params.search.cank2 = '3';
                    params.search.fapzl = "2";
                    params.search.cank1 = "3";
                }
            }
            this.$https.fetchPost('/invoice/issueInfo/getDocList', params).then(res => {
                this.$nextTick(() => {
                    this.tableHeight = this.diagheightzhengshutiankai();
                    setTimeout(() => {
                        this.$refs.multipleTable.doLayout();
                    }, 500);
                    window.onresize = () => {
                        this.tableHeight = this.diagheightzhengshutiankai();
                        setTimeout(() => {
                            this.$refs.multipleTable.doLayout();
                        }, 500);
                    };
                });
                this.totalcount = res.data.count;
                // console.log(this.total)
                this.tableData = res.data.data;
            });
        },

        closediagew() {
            this.Preview = false;
        },
        /* 开票管理表格区--发票预览 */
        handleClick(row, title) {
            let params = row.id;
            this.$https.fetchPost('felec/positiveInvoice/getDocInformById', params).then(res => {
                if (res.data.code == '200') {
                    //发票明细
                    this.priceall = [];
                    for (var i = 0; i < res.data.data.detailVos.length; i++) {
                        if (res.data.data.detailVos[i].faphxz == '1') {
                            this.priceall.push({
                                taxCode: res.data.data.detailVos[i].shuisbm,
                                goodsName: res.data.data.detailVos[i].shangpmc,
                                chooseMoney: res.data.data.detailVos[i].jine,
                                taxRate: res.data.data.detailVos[i].shuil,
                                taxRatemoney: res.data.data.detailVos[i].shuie,
                                itemNo: res.data.data.detailVos[i].hangh,
                                type: 1
                            });
                        } else {
                            this.stateall.istaxincluded = res.data.data.detailVos[i].hansbz == 1 ? true : false;
                            this.priceall.push({
                                unitPrice: res.data.data.detailVos[i].danj,
                                unit: res.data.data.detailVos[i].danw,
                                spec: res.data.data.detailVos[i].guigxh,
                                itemNo: res.data.data.detailVos[i].hangh,
                                chooseMoney: res.data.data.detailVos[i].jine,
                                taxCode: res.data.data.detailVos[i].shuisbm,
                                goodsName: res.data.data.detailVos[i].shangpmc,
                                quantity: res.data.data.detailVos[i].shangpsl,
                                taxRatemoney: res.data.data.detailVos[i].shuie,
                                taxRate: res.data.data.detailVos[i].shuil,
                                type: res.data.data.detailVos[i].faphxz
                            });
                        }
                    }
                    //开票人
                    this.kaipr = res.data.data.doc.kaipr;
                    //备注
                    this.bztext = res.data.data.doc.beiz;
                    //发票类型代码
                    this.stateall.choosetitleindex = row.faplxdm;
                    this.stateall.faphm = res.data.data.doc.faphm;
                    this.stateall.kaiprq = res.data.data.doc.kaiprq;
                    //购方信息
                    this.ruleFormb.address = res.data.data.doc.goufdzdh;
                    this.ruleFormb.customerName = res.data.data.doc.goufmc;
                    this.ruleFormb.customerNumber = res.data.data.doc.customerNo;
                    this.ruleFormb.taxIdentificationNumber = res.data.data.doc.goufsbh;
                    this.ruleFormb.bank = res.data.data.doc.goufyhzh;
                    //销方
                    this.ruleFormbxiao.addressPhone = res.data.data.doc.xiaofdzdh;
                    this.ruleFormbxiao.name = res.data.data.doc.xiaofmc;
                    this.ruleFormbxiao.taxNumber = res.data.data.doc.xiaofsbh;
                    this.ruleFormbxiao.bankAccount = res.data.data.doc.xiaofyhzh;
                    //经办人信息
                    this.jbrdata.xingm = res.data.data.doc.goufjbrxm;
                    this.jbrdata.zhengjhm = res.data.data.doc.goumfjbrzjhm;
                    this.jbrdata.zhengjlx = res.data.data.doc.goumfjbrzjlx;
                    this.jbrdata.guoj = res.data.data.doc.jinbrgj;
                    this.jbrdata.qiybh = res.data.data.doc.jinbrzrrnsrsbh;
                    //单据号
                    this.danjh = res.data.data.doc.danjh;
                    //特定业务
                    this.tdywxz = res.data.data.doc.tedywlx == null ? '' : res.data.data.doc.tedywlx;
                    //差额征税 减按征税
                    this.cezsxz = res.data.data.doc.chaezslx == null ? '' : res.data.data.doc.chaezslx;
                    this.jazsxz = res.data.data.doc.jianazs == null ? '' : res.data.data.doc.jianazs;
                    //合计
                    this.totalall.pricetotal = res.data.data.doc.hejje;
                    this.totalall.taxtotal = res.data.data.doc.hejse;
                    this.totalall.jiastotal = res.data.data.doc.jiashj;
                    this.totalall.jiastotalda = this.pricetonew(this.totalall.jiastotal);
                    //特定业务类型
                    if (res.data.data.specificBusinessData != null) {
                        this.tedxx = res.data.data.specificBusinessData;
                        this.tedxx.zulqqzulqz = ['', ''];
                        this.tedxx.zulqqzulqz[0] = res.data.data.specificBusinessData.zulqq;
                        this.tedxx.zulqqzulqz[1] = res.data.data.specificBusinessData.zulqz;
                    }
                    //附加内容
                    this.srk = [];
                    for (var i = 0; i < res.data.data.additionalElementsVos.length; i++) {
                        this.srk.push({
                            fujxxmc: res.data.data.additionalElementsVos[i].fujysmc,
                            deit: res.data.data.additionalElementsVos[i].fujysnr,
                            shujlx: res.data.data.additionalElementsVos[i].shujlx,
                            id: res.data.data.additionalElementsVos[i].id
                        });
                    }
                    this.title = '电子发票(普通发票)';
                    this.id = row.id;
                    this.Preview = true;
                } else {
                    this.$message.error(res.data.message);
                }
            });
            // 记号记号
        },

        /* 关闭开票弹框 */
        closeouterVisible() {
            this.outerVisible = false;
        },
        forhongchong(row) {
            if (row.documentStatus != '4') {
                this.$message.error('只能对已开票的数据进行红冲！');
                return
            }
            let params = row.id;
            this.$https.fetchPost('felec/positiveInvoice/getDocInformById', params).then(res => {
                if (res.data.code == '200') {
                    //发票明细
                    this.priceall = [];
                    for (var i = 0; i < res.data.data.detailVos.length; i++) {
                        if (res.data.data.detailVos[i].faphxz == '1') {
                            this.priceall.push({
                                cank0: res.data.data.detailVos[i].cank0,
                                cank1: res.data.data.detailVos[i].cank1,
                                cank2: res.data.data.detailVos[i].cank2,
                                cank3: res.data.data.detailVos[i].cank3,
                                cank4: res.data.data.detailVos[i].cank4,
                                cank5: res.data.data.detailVos[i].cank5,
                                cank6: res.data.data.detailVos[i].cank6,
                                cank7: res.data.data.detailVos[i].cank7,
                                cank8: res.data.data.detailVos[i].cank8,
                                cank9: res.data.data.detailVos[i].cank9,
                                createTime: res.data.data.detailVos[i].createTime,
                                danjh: res.data.data.detailVos[i].danjh,
                                fapdm: res.data.data.detailVos[i].fapdm,
                                faphm: res.data.data.detailVos[i].faphm,
                                id: res.data.data.detailVos[i].id,
                                lingslbz: res.data.data.detailVos[i].lingslbz,
                                rowNum: res.data.data.detailVos[i].rowNum,
                                shangpbm: res.data.data.detailVos[i].shangpbm,
                                updateTime: res.data.data.detailVos[i].updateTime,
                                version: res.data.data.detailVos[i].version,
                                youhzcbz: res.data.data.detailVos[i].youhzcbz,
                                youhzcsm: res.data.data.detailVos[i].youhzcsm,
                                zhekje: 0,
                                zhekl: null,
                                zhekse: 0,
                                taxCode: res.data.data.detailVos[i].shuisbm,
                                goodsName: res.data.data.detailVos[i].shangpmc,
                                chooseMoney: res.data.data.detailVos[i].jine > 0 ? res.data.data.detailVos[i].jine * -1 : res.data.data.detailVos[i].jine,
                                taxRate: res.data.data.detailVos[i].shuil,
                                taxRatemoney: res.data.data.detailVos[i].shuie > 0 ? res.data.data.detailVos[i].shuie * -1 : res.data.data.detailVos[i].shuie,
                                itemNo: res.data.data.detailVos[i].hangh,
                                unitPrice: res.data.data.detailVos[i].danj,
                                unit: res.data.data.detailVos[i].danw,
                                spec: res.data.data.detailVos[i].guigxh,
                                quantity: res.data.data.detailVos[i].shangpsl > 0 ? res.data.data.detailVos[i].shangpsl * -1 : res.data.data.detailVos[i].shangpsl,
                                hansbz: res.data.data.detailVos[i].hansbz == 1 ? true : false,
                                type: 1
                            });
                        } else {
                            this.stateall.istaxincluded = res.data.data.detailVos[i].hansbz == 1 ? true : false;
                            this.priceall.push({
                                cank0: res.data.data.detailVos[i].cank0,
                                cank1: res.data.data.detailVos[i].cank1,
                                cank2: res.data.data.detailVos[i].cank2,
                                cank3: res.data.data.detailVos[i].cank3,
                                cank4: res.data.data.detailVos[i].cank4,
                                cank5: res.data.data.detailVos[i].cank5,
                                cank6: res.data.data.detailVos[i].cank6,
                                cank7: res.data.data.detailVos[i].cank7,
                                cank8: res.data.data.detailVos[i].cank8,
                                cank9: res.data.data.detailVos[i].cank9,
                                createTime: res.data.data.detailVos[i].createTime,
                                danjh: res.data.data.detailVos[i].danjh,
                                fapdm: res.data.data.detailVos[i].fapdm,
                                faphm: res.data.data.detailVos[i].faphm,
                                id: res.data.data.detailVos[i].id,
                                lingslbz: res.data.data.detailVos[i].lingslbz,
                                rowNum: res.data.data.detailVos[i].rowNum,
                                shangpbm: res.data.data.detailVos[i].shangpbm,
                                updateTime: res.data.data.detailVos[i].updateTime,
                                version: res.data.data.detailVos[i].version,
                                youhzcbz: res.data.data.detailVos[i].youhzcbz,
                                youhzcsm: res.data.data.detailVos[i].youhzcsm,
                                zhekje: 0,
                                zhekl: null,
                                zhekse: 0,
                                hansbz: res.data.data.detailVos[i].hansbz == 1 ? true : false,
                                unitPrice: res.data.data.detailVos[i].danj,
                                unit: res.data.data.detailVos[i].danw,
                                spec: res.data.data.detailVos[i].guigxh,
                                itemNo: res.data.data.detailVos[i].hangh,
                                chooseMoney: res.data.data.detailVos[i].jine > 0 ? res.data.data.detailVos[i].jine * -1 : res.data.data.detailVos[i].jine,
                                taxCode: res.data.data.detailVos[i].shuisbm,
                                goodsName: res.data.data.detailVos[i].shangpmc,
                                quantity: res.data.data.detailVos[i].shangpsl > 0 ? res.data.data.detailVos[i].shangpsl * -1 : res.data.data.detailVos[i].shangpsl,
                                taxRatemoney: res.data.data.detailVos[i].shuie > 0 ? res.data.data.detailVos[i].shuie * -1 : res.data.data.detailVos[i].shuie,
                                taxRate: res.data.data.detailVos[i].shuil,
                                type: res.data.data.detailVos[i].faphxz
                            });
                        }
                    }
                    //开票人
                    this.kaipr = res.data.data.doc.kaipr;
                    //发票类型代码
                    this.stateall.choosetitleindex = this.activeName;
                    this.stateall.faphm = res.data.data.doc.faphm;
                    this.stateall.kaiprq = res.data.data.doc.kaiprq;
                    //备注
                    this.bztext = res.data.data.doc.beiz;
                    this.fuhr = res.data.data.doc.fuhr;
                    this.shoukr = res.data.data.doc.shoukr;
                    //购方信息
                    this.ruleFormb.address = res.data.data.doc.goufdzdh;
                    this.ruleFormb.customerName = res.data.data.doc.goufmc;
                    this.ruleFormb.customerNumber = res.data.data.doc.customerNo;
                    this.ruleFormb.taxIdentificationNumber = res.data.data.doc.goufsbh;
                    this.ruleFormb.bank = res.data.data.doc.goufyhzh;
                    //销方
                    this.ruleFormbxiao.addressPhone = res.data.data.doc.xiaofdzdh;
                    this.ruleFormbxiao.name = res.data.data.doc.xiaofmc;
                    this.ruleFormbxiao.taxNumber = res.data.data.doc.xiaofsbh;
                    this.ruleFormbxiao.bankAccount = res.data.data.doc.xiaofyhzh;
                    //经办人信息
                    this.jbrdata.xingm = res.data.data.doc.goufjbrxm;
                    this.jbrdata.zhengjhm = res.data.data.doc.goumfjbrzjhm;
                    this.jbrdata.zhengjlx = res.data.data.doc.goumfjbrzjlx;
                    this.jbrdata.guoj = res.data.data.doc.jinbrgj;
                    this.jbrdata.qiybh = res.data.data.doc.jinbrzrrnsrsbh;
                    //单据号
                    this.danjh = res.data.data.doc.danjh;
                    //特定业务
                    this.tdywxz = res.data.data.doc.tedywlx == null ? '' : res.data.data.doc.tedywlx;
                    //差额征税 减按征税
                    this.cezsxz = res.data.data.doc.chaezslx == null ? '' : res.data.data.doc.chaezslx;
                    this.jazsxz = res.data.data.doc.jianazs == null ? '' : res.data.data.doc.jianazs;
                    //合计
                    this.totalall.pricetotal = res.data.data.doc.hejje > 0 ? res.data.data.doc.hejje * -1 : res.data.data.doc.hejje;
                    this.totalall.taxtotal = res.data.data.doc.hejse > 0 ? res.data.data.doc.hejse * -1 : res.data.data.doc.hejse;
                    this.totalall.jiastotal = res.data.data.doc.jiashj > 0 ? res.data.data.doc.jiashj * -1 : res.data.data.doc.jiashj;
                    this.totalall.jiastotalda = this.pricetonew(this.totalall.jiastotal);
                    //特定业务类型
                    if (res.data.data.specificBusinessData != null) {
                        this.tedxx = res.data.data.specificBusinessData;
                        this.tedxx.zulqqzulqz = ['', ''];
                        this.tedxx.zulqqzulqz[0] = res.data.data.specificBusinessData.zulqq;
                        this.tedxx.zulqqzulqz[1] = res.data.data.specificBusinessData.zulqz;
                    }
                    //附加内容
                    this.srk = [];
                    for (var i = 0; i < res.data.data.additionalElementsVos.length; i++) {
                        this.srk.push({
                            fujxxmc: res.data.data.additionalElementsVos[i].fujysmc,
                            deit: res.data.data.additionalElementsVos[i].fujysnr,
                            shujlx: res.data.data.additionalElementsVos[i].shujlx,
                            id: res.data.data.additionalElementsVos[i].id,
                            version: res.data.data.additionalElementsVos[i].version,
                            createTime: res.data.data.additionalElementsVos[i].createTime,
                            updateTime: res.data.data.additionalElementsVos[i].updateTime,
                            danjh: res.data.data.additionalElementsVos[i].danjh,
                            qiybh: res.data.data.additionalElementsVos[i].qiybh,
                            fujysmc: res.data.data.additionalElementsVos[i].fujysmc,
                            fujysnr: res.data.data.additionalElementsVos[i].fujysnr
                        });
                    }
                    this.title = '单据编辑-数电电子普票填开';
                    this.id = row.id;
                    this.itemVlue = row
                    this.entering = true;
                } else {
                    this.$message.error(res.data.message);
                }
            });
        },
        forhongchongck(row) {
            this.kaijuType = 'single';
            this.selectRow = JSON.parse(JSON.stringify(row));
            this.selectRows = [];
            this.selectRows.push(this.selectRow);
            this.$confirm('此操作将红冲重开该单据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.getKaipjList().then(res => {
                        //  票面信息确认
                        // this.doRedLetter("编辑发票");
                    });
                })
                .catch(() => {});
        },
        /* 子传父 */
        closekgdialog(e) {
            this.kgdialog = e;
        },
        /* 筛选 */
        forserchshai() {
            this.cxdialog = false;
        },
        forcloseshai() {
            this.cxdialog = false;
        },
        handleSizeChange(val) {
            this.pagenum = val;
            if (this.totalcount != 0) {
                this.getDocList();
            }
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getDocList();
        },

        doOpenInvoiceDialog(message) {
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    switch (this.kaijuType) {
                        case 'single':
                            this.doRedLetter('编辑发票');
                            break;
                        case 'batch':
                            // this.doRedLetterBatch();
                            this.doOneRedLetterBatch();
                            break;
                    }
                })
                .catch(() => {});
        },

        radiochange(row) {
            this.kaipzddm = row.kaipjbh;
        },
        excelExport() {
            if (this.tableData.length < 1) {
                this.$message.error('数据为空,无法导出');
                return false;
            }
            let url = this.$https.baseURL + 'excel/getDocExcel'; //请求下载文件的地址
            let token = localStorage.getItem('token');
            this.searchalllist.type = '1';
            let param = JSON.parse(JSON.stringify(this.searchalllist));
            var ids = [];
            if (this.selectRows) {
                this.selectRows.forEach(item => {
                    ids.push(item.id);
                });
            }
            param.pagenum = this.pagenum;
            param.page = this.page;
            param.serchval = this.serchval;
            if (param.fpalldate) {
                param.fpalldate = param.fpalldate[0] + ',' + param.fpalldate[1];
            }
            param.headTitle = this.checkmeauList;
            param.headFiled = this.checkHeadFiled.toString();
            param.ids = ids;
            if ((token != '') & (token != null)) {
                axios.defaults.headers.common['token'] = token;
            }
            axios
                .post(url, param, { responseType: 'blob' })
                .then(res => {
                    if (!res) return;
                    let blob = new Blob([res.data], {
                        type: 'blob'
                    });
                    let url = window.URL.createObjectURL(blob);
                    let aLink = document.createElement('a');
                    aLink.style.display = 'none';
                    aLink.href = url;
                    aLink.setAttribute('download', '红冲发票.xls'); // 下载的文件
                    document.body.appendChild(aLink);
                    aLink.click();
                    document.body.removeChild(aLink);
                    window.URL.revokeObjectURL(url);
                    // let blob = new Blob([res.data], {type: "application/vnd.ms-excel"});
                    // let objectUrl = URL.createObjectURL(blob);
                    // window.location.href = objectUrl;
                })
                .catch(error => {
                    this.$message.error(error);
                });
        },
        async getKaipjList() {
            //	获取开票机信息
            this.$https.fetchPost('/doc/getKaipjList').then(res => {
                console.log(JSON.parse(res.data.obj));
                this.tableDatakp = JSON.parse(res.data.obj);
                // 选择开票机dialog隐藏
                this.kgdialog = true;
            });
        },
        submitFrom() {
            var param = {};
            var ids = [];
            this.selectRows.forEach(item => {
                ids.push(item.id);
            });
            param.ids = ids;
            param.text = this.formdata.text;

            this.$https.fetchPost('/doc/updateZidysm2', param).then(res => {
                if (res.data.success) {
                    this.dialogApproval = false;
                    this.getDocList();
                }
            });
        },
        //修改自定义说明二
        openUpdateZidysm2() {
            if (this.selectCount < 1) {
                this.$message({
                    type: 'error',
                    message: '请选择需要修改自定义说明的单据。'
                });
                return;
            }
            this.dialogApproval = true;
            if (this.$refs.taxform) {
                this.$nextTick(() => {
                    this.$refs.taxform.clearValidate();
                });
            }
        }, //强制红冲修改状态
        updateRedBluntSign(state) {
            if (this.selectCount < 1) {
                this.$message({
                    type: 'error',
                    message: '请选择需要控制红冲的单据。'
                });
                return;
            }
            var message;
            if (state == 1) {
                message = '此操作将发票置为强制红冲状态，红冲时可能存在重复红冲风险，是否继续？';
            } else {
                message = '是否确定取消强制红冲？';
            }
            this.$confirm(message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    var param = {};
                    var ids = new Array();
                    var isSuccess = false;
                    this.selectRows.forEach(item => {
                        if (item.id) {
                            ids.push(item.id);
                        } else {
                            isSuccess = true;
                        }
                    });
                    if (isSuccess) {
                        this.$message({
                            type: 'error',
                            message: '当前有红字申请单未关联到发票，请修改后提交。'
                        });
                        return;
                    }
                    param.state = state;
                    param.ids = ids;
                    this.$https.fetchPost('/doc/updateForceRedFlushStatus', param).then(res => {
                        if (res.data.success) {
                            this.getDocList();
                        }
                    });
                })
                .catch(() => {});
        }
    }
};
</script>

<style scoped="scoped" lang="less">
/deep/ .el-input--suffix .el-input__inner {
    padding-right: 15px;
}

.shousuo:extend(.Verticalcenter) {
    height: 20px;
    margin-bottom: 10px;
    background-color: #f8f8f8;
}

.shousuo:hover {
    background: #f8f8f8;
}

.minheight {
    height: 50px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.maxheight {
    height: 200px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.bt1 {
    width: 56px;
    height: 30px;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 500;
    color: #2f66fc;
}

.bt2 {
    width: 93px;
    height: 32px;
    background: #2f66fc;
    border-radius: 2px;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    color: #ffffff;
}

.bt3 {
    width: 93px;
    height: 32px;
    background: #e2e2e2;
    border-radius: 2px;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    margin-left: 53px;
    color: #ffffff;
}

/* /deep/.el-dialog__body{
    padding: 0;
} */

/deep/ .el-table--small td {
    padding: 4px 0;
}

/deep/ .el-table__body-wrapper {
    min-height: 160px;
}

/deep/ .el-dialog__body {
    padding: 0px 20px;
}

.areatable {
    margin-top: 16px;
}

.aftericon:extend(.Centerhorizontally) {
    width: 36px;
    height: 33px;
    background: #ffffff;
    box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.09);
    opacity: 1;
    border-radius: 3px;
    margin-left: 20px;
}

.aftericon > img {
    width: 16px;
    height: 16px;
}

.areacontent {
    margin-left: 21px;
}
</style>
